<template>
  <div class="fs-11">
    <template v-if="loading">
      <div class="text-center">
        <div class="spinner-border text-primary my-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <div class="row" v-else>

      <div class="col-md-4">
        <h5>{{ lexicon.drop_order_num }}:</h5>
        <table class="table table-sm">
          <tr>
            <td class="border-0">{{ lexicon.drop_receiver }}</td>
            <td class="text-primary">{{ order.name }}</td>
          </tr>
          <tr>
            <td class="border-0">{{ lexicon.drop_phone }}</td>
            <td class="text-primary">{{ order.phone }}</td>
          </tr>
          <tr>
            <td class="border-0">{{ lexicon.drop_customer_city }}</td>
            <td class="text-primary">{{ order.city }}</td>
          </tr>
          <tr>
            <td class="border-0">{{ lexicon.drop_address }}</td>
            <td class="text-primary">{{ order.sklad }}</td>
          </tr>
          <tr>
            <td class="border-0">{{ lexicon.drop_afterpay }}</td>
            <td class="text-primary">{{ order.nal > 0 ? order.nal + lexicon.drop_uah_sign : lexicon.drop_no }}</td>
          </tr>
          <tr>
            <td class="border-0">{{ lexicon.drop_delivery_payer }}</td>
            <td class="text-primary">{{ order.pay_del > 1 ? lexicon.drop_sender : lexicon.drop_receiver }}</td>
          </tr>
          <tr v-if="(order.nal > 0)">
            <td class="border-0">{{ lexicon.drop_af_payer }}</td>
            <td class="text-primary">{{ (order.pay_redel == 1) ? lexicon.drop_receiver : lexicon.drop_sender }}</td>
          </tr>
          <tr>
            <td class="border-0">{{ lexicon.drop_delivery_status }}</td>
            <td class="text-primary">{{ order.np_status }}</td>
          </tr>
        </table>
      </div>
      <div class="col-md-4">
        <h5>{{ lexicon.drop_products }}:</h5>
        <table class="table table-sm">
          <tr>
            <th>
              {{ lexicon.drop_photo }}
            </th>
            <th>
              {{ lexicon.drop_product }}
            </th>
            <th>{{ lexicon.drop_qty }}</th>
          </tr>
          <tr v-for="product in order.products" :key="product.product_id">
            <td class="border-0">
              <img :src="product.thumb" class=" product-info-img">
            </td>
            <td>
              {{ product.article }}
              <br>
              <small>{{ product.pagetitle }}</small>
            </td>
            <td class="text-center">{{ product.count }}&nbsp;x&nbsp;{{ product.price }}&nbsp;=&nbsp;{{ product.cost }}
              <span class="text-muted">{{ lexicon[order.cc] }}</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="col-md-4">
        <div class="row mb-2" v-if="order.cancel_available">
          <div class="col-12">
            <button class="btn btn-danger btn-block" type="button" @click="cancelOrder" >
            <i class="feather icon-trash-2" ></i>
               Анулювати замовлення
            </button>

          </div>
        </div>
        <h5>{{ lexicon.drop_history }}:</h5>
        <div class="row">
          <div class="col-12">
            <div class="input-group">
              <div class="input-group-prepend" v-if="user.admin && order.np_status_id <= 1">
                <span class="input-group-text">{{ lexicon.drop_ttn_num }}</span>
              </div>
              <input :readonly="!isEditable" :placeholder="lexicon.drop_ttn_num" type="number" v-model="order.ttn"
                     class="form-control">
              <div class="input-group-append"
                   v-if="user.admin && (order.np_status_id <= 1 || order.np_status_id === 2) ">
                <button class="btn btn-sm btn-primary " @click="editTtn()">
                  <i class="feather" :class="{'icon-save':isEditable,'icon-edit':!isEditable}"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 my-1" v-if="order.props.delivery.type === 'np'">

            <div class="input-group">
              <div class="input-group-prepend" v-if="user.admin && order.np_status_id <= 1">
                <span class="input-group-text">{{ lexicon.drop_customer_branch }}</span>
              </div>
              <select :placeholder="lexicon.drop_customer_branch" class="form-control" v-model="sklad"
                      :disabled="!isEditableStock">
                <option v-for="stock in order.stocks" :key="stock.ref"
                        v-bind:value="{'sklad_ref':stock.ref,'sklad':stock.name}">{{ stock.name }}
                </option>
              </select>
              <div class="input-group-append" v-if="user.admin && order.np_status_id <= 1">
                <button class="btn btn-sm btn-primary " @click="editSkald()">
                  <i class="feather" :class="{'icon-save':isEditableStock,'icon-edit':!isEditableStock}"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 my-1" v-if="order.props.delivery.type === 'up'">
            <div class="input-group">
              <div class="input-group-prepend" v-if="user.admin && order.np_status_id <= 1">
                <span class="input-group-text">{{ lexicon.drop_zip }}</span>
              </div>
              <input :placeholder="lexicon.drop_zip" class="form-control" v-model="order.sklad_ref"
                     :disabled="!isEditableStock">
              <div class="input-group-append" v-if="user.admin && order.np_status_id <= 1">
                <button class="btn btn-sm btn-primary " @click="editZip()">
                  <i class="feather" :class="{'icon-save':isEditableStock,'icon-edit':!isEditableStock}"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <table class="table table-sm">
          <tr>
            <th>
              {{ lexicon.drop_date }}
            </th>
            <th>
              {{ lexicon.drop_status }}
            </th>
          </tr>
          <tr v-for="log in order.logs" :key="log.id">
            <td class="border-0">
              {{ $moment(log.createdon).format('DD.MM.YYYY HH:mm') }}
            </td>
            <td>
              {{ log.comment }}
            </td>
          </tr>
        </table>
      </div>
    </div>

  </div>
</template>

<script>

import {mapGetters, mapState} from 'vuex'
import axios from "axios";

export default {
  name: "OrderInfo",
  props: ['data', 'index'],
  data() {
    return {
      loading: true,
      order: {},
      sklad: {
        'sklad_ref': '',
        'sklad': ''
      },
      isEditable: false,
      isEditableStock: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    ...mapState({
      lexicon: 'lexicon',
    })
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      axios.post('order/', {'id': this.data.id}).then((response) => {
        this.loading = false
        this.order = response.data.data
        this.sklad.sklad = this.order.sklad
        this.sklad.sklad_ref = this.order.sklad_ref
      })
    },
    editTtn() {
      if (!this.isEditable) {
        this.isEditable = true
        return;
      }
      this.loading = true
      this.isEditable = false;
      axios.post('ttn/update/', {'id': this.order.id, 'ttn': this.order.ttn}).then((response) => {
        this.loading = false
        if (response.data.success) {
          this.fetchData()
        }

      })
    },
    cancelOrder() {
      this.loading = true
      this.isEditable = false;
      axios.post('order/cancel/', {'id': this.order.id}).then((response) => {
        this.loading = false
        if (response.data.success) {
          // this.$emit('cancelled',this.order.id)
          this.fetchData()
        }

      })
    },
    editZip() {
      if (!this.isEditableStock) {

        this.isEditableStock = true
        return;
      }
      axios.post('city/update/', {
        'id': this.order.id,
        'sklad_ref': this.order.sklad_ref,
        'sklad': "№ " + this.order.sklad_ref,
      }).then((response) => {
        this.loading = false
        if (response.data.success) {
          this.fetchData()
        }

      })
    },
    editSkald() {
      if (!this.isEditableStock) {
        axios.post('city/', {'ref': this.order.city_ref, 'type': 'sklad'}).then((response) => {
          this.loading = false
          if (response.data.success) {
            this.order.stocks = response.data.data;
            this.isEditableStock = true
          }
        })
        return;
      }
      this.loading = true
      this.isEditableStock = false;
      axios.post('city/update/', {
        'id': this.order.id,
        'sklad_ref': this.sklad.sklad_ref,
        'sklad': this.sklad.sklad
      }).then((response) => {
        this.loading = false
        if (response.data.success) {
          this.fetchData()
        }

      })
    },

  }
}
</script>